import type * as React from 'react';

function SvgClockDate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 14 14" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M7.0000091,0 C3.15791821,0 0.0313584162,3.12666667 0.000248368492,6.95333333 C-0.0153066554,8.82 0.700224442,10.5933333 2.02240147,11.9155556 C3.32902347,13.2533333 5.08674117,13.9844444 6.95334403,14 C6.95334403,14 7.0000091,14 7.0000091,14 C10.8421,14 13.9686598,10.8733333 13.9997698,7.04666667 C14.0308799,3.18888889 10.9043201,0.0311111111 7.0000091,0 Z M7.0000091,13.0511111 L6.95334403,13.0511111 C5.33562155,13.0355556 3.82678424,12.3977778 2.67571247,11.2466667 C1.55575075,10.1111111 0.9335498,8.58666667 0.949104824,6.96888889 C0.964659847,3.65555556 3.68678902,0.948888889 7.04667417,0.948888889 C10.3910043,0.964444444 13.0820234,3.70222222 13.0664684,7.04666667 C13.0353584,10.36 10.3132292,13.0511111 7.0000091,13.0511111 Z"
          fill="currentColor"
          fillRule="nonzero"
        />
        <path
          d="M9.57664234,7.99421965 L6.84671533,7.99421965 L6.84671533,3.50289017 C6.84671533,3.22543353 6.65693431,3 6.42335766,3 C6.18978102,3 6,3.22543353 6,3.50289017 L6,8.49710983 C6,8.77456647 6.18978102,9 6.42335766,9 L9.57664234,9 C9.81021898,9 10,8.77456647 10,8.49710983 C10,8.21965318 9.81021898,7.99421965 9.57664234,7.99421965 Z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgClockDate;
